import setItemState from "./setItemState";
import {
  isNotRemoved,
  isDeleting,
  isToBagInProgress
} from "../../selectors/itemStateSelectors";
import { ITEM_STATE_SAVED_ITEM_LOADED } from "../../constants";

export default (state, { payload: { id } }) => {
  const newState = id
    ? setItemState(state, id, ITEM_STATE_SAVED_ITEM_LOADED)
    : state;

  if (
    !newState.items.some(isDeleting) &&
    !newState.items.some(isToBagInProgress)
  ) {
    newState.items = newState.items.filter(isNotRemoved);
  }

  return {
    ...newState,
    displayableItemCount: newState.items.length
  };
};
